import { render } from "./SignupView.vue?vue&type=template&id=4c12f5ba&scoped=true"
import script from "./SignupView.vue?vue&type=script&lang=js"
export * from "./SignupView.vue?vue&type=script&lang=js"

import "./SignupView.vue?vue&type=style&index=0&id=4c12f5ba&scoped=true&lang=css"

import exportComponent from "/Users/alejandrobernal/Documents/fbc/fbc-ecommerce-main-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c12f5ba"]])

export default __exports__